import Share from 'ninelines-sharing';
import html2canvas from 'html2canvas';
import Draggable from 'gsap/Draggable';
import 'cropperjs';
import 'jquery-cropper';

import helpers from '../helpers';
import vars from '../helpers';

gsap.registerPlugin(Draggable);

const $test = $('.test');
const $intro = $test.find('.test__intro');
const $step = $test.find('.test__step');
const $result = $test.find('.test__result');
const $prompt = $test.find('.test__prompt');
const $progress = $test.find('.test__progress');
const $progressCircle = $test.find('.test__progress-circle');
const $share = $test.find('.test__share');
const $resultVideo = $test.find('.test__result-video');

const $moon = $test.find('.test__moon');
const $cosmonaut = $test.find('.test__cosmonaut');
const $cloudLeft = $test.find('.test__cloud-left');
const $cloudRight = $test.find('.test__cloud-right');

const $text = $test.find('.test__text');
const $textQuestion = $text.filter('.test__text--question');
const $textResult = $text.filter('.test__text--result');
const $textPrompt = $text.filter('.test__text--prompt');

const $button = $test.find('.test__button');
const $buttonPrev = $button.filter('.test__button--prev');
const $buttonNext = $button.filter('.test__button--next');
const $buttonUpload = $button.filter('.test__button--upload');
const $buttonUploadPhoto = $button.filter('.test__button--upload-photo');
const $buttonRepeat = $button.filter('.test__button--repeat');
const $buttonUploadError = $button.filter('.test__button--error');

const $photo = $test.find('.test__photo');
const $photoDefault = $photo.not('.test__photo--share');
const $photoShare = $photo.filter('.test__photo--share');

const $promptButton = $test.find('.test__prompt-button');
const $promptCurrent = $promptButton.find('.test__prompt-current');
const $promptTotal = $promptButton.find('.test__prompt-total');

const $countCurrent = $test.find('.test__count-current');
const $countTotal = $test.find('.test__count-total');

const $bottomBarStep = $step.find('.test__bottom-bar');
const $bottomBarResult = $result.find('.test__bottom-bar');

const $slider = $test.find('.test__slider');
const $dots = $test.find('.test__dots');
const $question = $test.find('.test__question');
const $year = $test.find('.test__year');
const $month = $test.find('.test__month');
const $day = $test.find('.test__day');
const $list = $test.find('.test__list');
const $resultLine = $result.find('.test__line');
const $info = $test.find('.test__info');
const $file = $test.find('.test__file');
const $social = $test.find('.test__social');
const $error = $test.find('.test__error');
const $cropper = $test.find('.test__cropper');
const $cropperImage = $test.find('.test__cropper-image');
const $buttonUploadCropper = $test.find('.test__button--cropper-get');
const $buttonOnCropper = $test.find('.test__button--cropper-on');

const data = window.data.test;
const promptMaxCount = 3;
const fileExtensions = ['image/jpeg', 'image/png', 'image/gif'];
const fileMaxSize = 3 * 1024 * 1024;
const fileErrorMessages = {
	type: 'Ошибка! Неверный формат файла.',
	size: 'Ошибка! Размер файла превышает максимальное значение.',
};

let isAnimating = false;
let questionCurrent = 0;
let questionSelectedAnswer = null;
let promptLeftCount = promptMaxCount;
let selectedAnswers = [];
let photoDraggable = null;
let photoCropper = false;
let promtShowCount = [];

const sliderDestroy = () => {
	if (helpers.isMobile() || !$slider.hasClass('slick-initialized')) {
		return;
	}

	$slider
		.find('.test__arrow-next')
		.off('.test')
		.end()
		.slick('unslick');

	$dots
		.find('.test__dot')
		.off('.test')
		.end()
		.empty();
};

const sliderReset = () => {
	if (!helpers.isMobile() || !$slider.hasClass('slick-initialized')) {
		return;
	}

	$slider.slick('slickGoTo', 0);
};

const sliderCreate = () => {
	if (!helpers.isMobile() || $slider.hasClass('slick-initialized')) {
		return;
	}

	let dots = '';

	$slider.slick({
		arrows: false,
		infinite: false,
		speed: 500,
	});

	$slider.on('afterChange', (e, slick, curSlide) => {
		$dots
			.find('.test__dot')
			.removeClass('is-active')
			.filter(`[data-slide-index="${curSlide}"]`)
			.addClass('is-active');
	});

	for (let i = 0; i < $slider.get(0).slick.slideCount; i++) {
		dots += `<button type="button" class="test__dot" data-slide-index="${i}"></button>`;
	}

	$dots.html(dots);
	$slider.slick('slickGoTo', 0);

	$slider
		.find('.test__arrow-next')
		.on('click.test', () => {
			$slider.slick('slickNext');
		});

	$dots
		.find('.test__dot')
		.on('click.test', (e) => {
			$slider.slick('slickGoTo', e.currentTarget.dataset.slideIndex);
		});
};

const selectedAnswersGetCorrect = () => {
	return selectedAnswers.filter((answer) => answer.correct);
};

const getCurrentResultIndex = () => {
	const correctAnswersCount = selectedAnswersGetCorrect().length;

	return data.results.indexOf(data.results.find((result) => correctAnswersCount <= result.count));
};

const shareOpen = (social, image, index, promise = Promise.resolve()) => {
	const shareWindow = Share.openWindow('');

	promise
		.then((newImage) => {
			if (typeof newImage !== 'undefined') {
				image = newImage;
			}

			const url = `${location.origin + location.pathname}share-test.php?image=${image}&index=${index}`;

			shareWindow.location = Share.getUrl(social, url);
		})
		.catch(() => {
			shareWindow.close();
		});
};

const shareCreateImage = () => {
	return new Promise((resolve) => {
		html2canvas($share.get(0), {
			logging: false,
			scrollX: 0,
			scrollY: 0,
		})
			.then((canvas) => {
				const image = canvas.toDataURL('image/jpeg', 1.0);

				$.ajax({
					url: `${location.origin + location.pathname}save-share-image.php`,
					type: 'POST',
					data: {
						image,
					},
					dataType: 'json',
					success(response) {
						if (!response || !response.image) {
							resolve('main');

							return;
						}

						resolve(response.image);
					},
					error(xhr) {
						alert(`${xhr.status}: ${xhr.statusText}`); // eslint-disable-line no-alert
					},
				});
			});
	});
};

const share = (e) => {
	const social = e.currentTarget.dataset.name;
	const resultIndex = getCurrentResultIndex();

	if ($test.hasClass('is-uploaded')) {
		shareOpen(social, '', resultIndex, shareCreateImage());
	} else {
		shareOpen(social, 'main', resultIndex);
	}
};

const photoDraggableSetSharePosition = () => {
	if (photoDraggable === null) {
		return;
	}

	const $photoShareImage = $photoShare.find('img');

	const scale = $photoShare.outerWidth() / $photoDefault.outerWidth();

	gsap.set($photoShareImage, {
		x: photoDraggable.x * scale,
		y: photoDraggable.y * scale,
		scale,
	});
};

const photoDraggableDestroy = () => {
	if (photoDraggable === null) {
		return;
	}

	photoDraggable.kill();

	photoDraggable = null;
};

const photoDraggableInit = () => {
	photoDraggable = Draggable.create($photoDefault.find('img'), {
		bounds: $photoDefault,
		onDrag: photoDraggableSetSharePosition,
	})[0];

	photoDraggableSetSharePosition();
};

const fileSetPhoto = (file) => {
	const reader = new FileReader();
	const image = new Image();

	reader.onload = (e) => {
		image.src = e.target.result;
		image.alt = 'Photo';

		$test.addClass('is-uploaded');
		$cropper.fadeIn(300);
		$cropperImage.html(image);

		initCropper();
	};

	reader.readAsDataURL(file);
	helpers.$document.trigger('test-photo-success');
};

const fileClear = (withInput = true) => {
	photoDraggableDestroy();

	$test.removeClass('is-uploaded');

	if (withInput) {
		$file
			.attr('type', 'text')
			.attr('type', 'file')
			.trigger('change');
	}
};

const fileUpload = () => {
	const file = $file.prop('files')[0];

	if (!file) {
		fileClear(false);

		return;
	}

	const extensions = $file.attr('accept') || fileExtensions;
	const maxSize = $file.data('max-size') ? $file.data('max-size') * 1024 * 1024 : fileMaxSize;

	let error = false;

	if (extensions.indexOf(file.type) < 0) {
		error = true;

		$error.fadeIn(300);
	} else if (file.size > maxSize) {
		error = true;

		$error.fadeIn(300);
	}

	if (error) {
		fileClear();

		return;
	} else if (error && photoCropper) {
		fileClear();
		$cropper.fadeOut(300);

		return;
	}

	fileSetPhoto(file);
};

const fileTrigger = () => {
	$file.trigger('click');
};

const fileTriggerError = () => {
	$file.trigger('click');
	$error.fadeOut(300);
};

const fileUploadState = () => {
	$test.addClass('is-uploading');
	vars.$document.trigger('test-animate-true');
};

const progressCircleSetPosition = () => {
	const $indexCurrent = $progress.find('.test__index.is-current');

	if ($indexCurrent.length) {
		$progressCircle
			.css('transform', `translateY(${$indexCurrent.offset().top}px)`)
			.addClass('is-active');
	} else {
		$progressCircle
			.removeClass('is-active')
			.removeAttr('style');
	}
};

const initCropper = () => {
	const $cropperImageImg = $cropperImage.find('img');
	const $cropperArrowLeft = $test.find('.test__cropper-arrow--left');
	const $cropperArrowRight = $test.find('.test__cropper-arrow--right');

	$cropperImageImg.cropper({
		aspectRatio: 4 / 3,
		viewMode: 3,
		dragMode: 'move',
	});

	vars.$document.trigger('test-animate-false');

	$cropperArrowLeft.on('click.test', ()=> {
		$cropperImageImg.cropper('rotate', -45);
	});

	$cropperArrowRight.on('click.test', ()=> {
		$cropperImageImg.cropper('rotate', 45);
	});

	$buttonUploadCropper.on('click.test', ()=> {
		photoCropper = false;
	});

	$buttonOnCropper.on('click.test', ()=> {
		$photo.find('img').attr('src', $cropperImageImg.cropper('getCroppedCanvas').toDataURL());
		$cropperImageImg.cropper('destroy');
		photoCropper = false;
		$cropper.fadeOut(300);

		$cropperArrowLeft.off('click.test');
		$cropperArrowRight.off('click.test');
		$buttonUploadCropper.off('click.test');
		$buttonOnCropper.off('click.test');
		$cropperImageImg.remove();
		vars.$document.trigger('scroll-animate-true');
		vars.$document.trigger('test-animate-true');
	});

	$buttonUploadCropper.on('click.test', ()=> {
		$cropperImageImg.cropper('destroy');
		photoCropper = false;
		$cropper.fadeOut(300);

		$cropperArrowLeft.off('click.test');
		$cropperArrowRight.off('click.test');
		$buttonUploadCropper.off('click.test');
		$buttonOnCropper.off('click.test');
		$cropperImageImg.remove();
		fileTrigger();
		vars.$document.trigger('scroll-animate-true');
	});

	vars.$document.on('test-cropper-destroy', () => {
		$cropperImageImg.cropper('destroy');
		photoCropper = false;
	});

	vars.$document.trigger('scroll-animate-false');

	photoCropper = true;
}

const progressCreate = () => {
	let html = '';

	for (let i = data.questions.length - 1; i >= 0; i--) {
		html += '<div class="test__index"></div>';
	}

	$progress.html(html);
};

const progressSetClass = (index, name) => {
	$progress
		.find(`.test__index:eq(${index})`)
		.removeClass('is-current is-correct is-wrong')
		.addClass(`is-${name}`);
};

const progressRemoveClass = (index, name) => {
	if (typeof index === 'undefined' && typeof name === 'undefined') {
		$progress
			.find('.test__index')
			.removeClass('is-current is-correct is-wrong');

		return;
	}

	$progress
		.find(`.test__index:eq(${index})`)
		.removeClass('is-current is-correct is-wrong')
		.removeClass(`is-${name}`);
};

const promptSetCount = () => {
	$promptCurrent.html(promptLeftCount);
	$promptTotal.html(promptMaxCount);
};

const promptShow = () => {
	if (!promptLeftCount || promtShowCount.indexOf(questionCurrent) >= 0) {
		return;
	}

	promtShowCount.push(questionCurrent)

	promptLeftCount -= 1;

	helpers.$document.trigger('test-promt', [questionCurrent + 1, 3 - promptLeftCount])

	$textPrompt.html(data.questions[questionCurrent].prompt);
	$prompt.addClass('is-active');
	$promptButton.addClass('is-active');

	promptSetCount();

};

const promptHide = () => {
	$prompt.removeClass('is-active');

	$promptButton
		.removeClass('is-active')
		.toggleClass('is-disabled', !promptLeftCount)
		.prop('disabled', !promptLeftCount);
};

const promptHideOnEscape = (e) => {
	if ($prompt.hasClass('is-active') && e.keyCode === 27) {
		promptHide();
	}
};

const promptHideOnClick = () => {
	if ($prompt.hasClass('is-active')) {
		promptHide();
	}
};

const promptToggle = (e) => {
	e.preventDefault();
	e.stopPropagation();

	($prompt.hasClass('is-active') ? promptHide : promptShow)();
};

const questionSet = () => {
	const question = data.questions[questionCurrent];
	const date = question.date.split(', ');
	const answers = question.answers.map((answer) => `<button type="button" class="test__answer">${answer}</button>`).join('');

	$year.html(date[0]);
	$month.html(date[1]);
	$day.html(date[2]);
	$textQuestion.html(question.text);
	$list.html(answers);

	helpers.$document.trigger('test-question', [questionCurrent + 1, question.text])

	progressSetClass(questionCurrent, 'current');
	progressCircleSetPosition();
};

const questionSelectAnswer = (e) => {
	const $answer = $list.find('.test__answer');
	const $currentAnster = $(e.currentTarget);

	$answer
		.removeClass('is-selected')
		.addClass('is-unselected');

	$currentAnster.addClass('is-selected');

	$buttonNext
		.removeClass('is-disabled')
		.prop('disabled', false);

	questionSelectedAnswer = $currentAnster.index();
};

const resultPlayAnimation = () => {
	return new Promise((resolve) => {
		const resultIndex = getCurrentResultIndex();

		const $resultVideoCurrent = $resultVideo.filter(`[data-index="${resultIndex}"]`);

		if (!$resultVideoCurrent) {
			resolve();

			return;
		}

		const $currentVideo = $resultVideoCurrent.find('video');
		const $currentVideoNode = $currentVideo.get(0);

		$resultVideoCurrent.addClass('is-active');

		$currentVideo.one('ended', () => {
			$resultVideoCurrent.removeClass('is-active');

			resolve();
		});

		$currentVideoNode.muted = true;
		$currentVideoNode.currentTime = 0;

		$currentVideoNode.play();
	});
};

const resultSet = () => {
	const correctAnswersCount = selectedAnswersGetCorrect().length;
	const text = data.results.find((result) => correctAnswersCount <= result.count).text;
	const pad = (num) => num < 10 ? `0${num}` : num; // eslint-disable-line no-confusing-arrow

	$countCurrent.html(pad(correctAnswersCount));
	$countTotal.html(pad(data.questions.length));
	$textResult.html(text);

	helpers.$document.trigger('test-result', [text, correctAnswersCount])
};

const repeat = () => {
	return new Promise((resolve) => {
		if (isAnimating) {
			resolve();

			return;
		}

		isAnimating = true;
		questionCurrent = 0;
		questionSelectedAnswer = null;
		promptLeftCount = promptMaxCount;
		selectedAnswers = [];
		promtShowCount = [];

		helpers.$document.trigger('test-repear')

		if (!helpers.isMobile()) {
			$test.removeClass('is-finished');
		}

		$buttonNext
			.addClass('is-disabled')
			.prop('disabled', true);

		$promptButton
			.toggleClass('is-disabled', !promptLeftCount)
			.prop('disabled', !promptLeftCount);

		progressRemoveClass();
		promptSetCount();
		fileClear();

		gsap
			.timeline({
				onComplete() {
					$test
						.removeClass('is-finished is-uploading')
						.addClass('is-intro');

					$resultLine.removeClass('is-active');

					isAnimating = false;

					resolve();
				},
			})
			.to($bottomBarResult, {
				yPercent: 100,
			})
			.to($result, {
				clearProps: 'all',
				autoAlpha: 0,
				xPercent: helpers.isMobile() ? 0 : -20,
			})
			.call(() => {
				$intro.removeClass('is-hidden');
				$result.addClass('is-hidden');

				gsap.set($bottomBarResult, {clearProps: 'all'});

				sliderReset();
			})
			.from($intro, {
				clearProps: 'all',
				autoAlpha: 0,
				xPercent: helpers.isMobile() ? 0 : -20,
			});
	});
};

const finish = () => {
	return new Promise((resolve) => {
		if (isAnimating) {
			resolve();

			return;
		}

		isAnimating = true;

		resultSet();
		progressCircleSetPosition();

		const timeline = gsap
			.timeline({
				onComplete() {
					if (helpers.isMobile()) {
						$info
							.stop()
							.animate({
								scrollTop: 0,
							}, 500);
					}

					isAnimating = false;

					resolve();
				},
			})
			.to($bottomBarStep, {
				yPercent: 100,
			})
			.to($step, {
				clearProps: 'all',
				autoAlpha: 0,
				xPercent: helpers.isMobile() ? 0 : -20,
			})
			.call(() => {
				$test
					.removeClass('is-started')
					.addClass('is-finished');

				$step.addClass('is-hidden');
				$result.removeClass('is-hidden');

				gsap.set($bottomBarStep, {clearProps: 'all'});
			})
			.call(async () => {
				timeline.pause();

				await resultPlayAnimation();

				timeline.play();
			}, null, '+=0.5')
			.from($result, {
				delay: 0.5,
				clearProps: 'all',
				autoAlpha: 0,
				xPercent: helpers.isMobile() ? 0 : -20,
			});

		if (!helpers.isMobile()) {
			timeline
				.from($resultLine, {
					clearProps: 'all',
					transition: 'none',
					opacity: 0,
					xPercent: -20,
				}, '-=0.25')
				.call(() => {
					$resultLine.addClass('is-active');
				})
				.from($result.find('.test__arrow-down, .test__photo-prompt, .test__photo-size'), {
					clearProps: 'all',
					opacity: 0,
					xPercent: -20,
				}, '-=0.25')
				.from([$buttonUpload, $result.find('.test__photo-ext')], {
					clearProps: 'all',
					opacity: 0,
					xPercent: -20,
				}, '-=0.25');
		}

		timeline.from($bottomBarResult, {
			clearProps: 'all',
			yPercent: 100,
		});
	});
};

const next = () => {
	return new Promise((resolve) => {
		if (isAnimating) {
			resolve();

			return;
		}

		isAnimating = true;

		const isCorrect = data.questions[questionCurrent].correct === questionSelectedAnswer;

		progressSetClass(questionCurrent, isCorrect ? 'correct' : 'wrong');

		selectedAnswers.push({
			index: questionSelectedAnswer,
			correct: isCorrect,
		});

		helpers.$document.trigger('test-answer', [questionCurrent + 1, isCorrect, questionSelectedAnswer + 1])

		if (helpers.isMobile()) {
			$question
				.stop()
				.animate({
					scrollTop: 0,
				}, 500);
		}

		if (questionCurrent + 1 >= data.questions.length) {
			isAnimating = false;

			finish();
			resolve();

			return;
		}

		gsap
			.timeline({
				onComplete() {
					isAnimating = false;

					resolve();
				},
			})
			.to($question, {
				autoAlpha: 0,
				xPercent: helpers.isMobile() ? 0 : -50,
			})
			.call(() => {
				$buttonNext
					.addClass('is-disabled')
					.prop('disabled', true);

				questionCurrent += 1;
				questionSelectedAnswer = null;

				questionSet();
			})
			.set($question, {
				xPercent: helpers.isMobile() ? 0 : 50,
			})
			.to($question, {
				clearProps: 'all',
				autoAlpha: 1,
				xPercent: 0,
			});
	});
};

const prev = () => {
	return new Promise((resolve) => {
		if (isAnimating) {
			resolve();

			return;
		}

		isAnimating = true;

		const timeline = gsap.timeline({
			onComplete() {
				isAnimating = false;

				resolve();
			},
		});

		if (questionCurrent) {
			progressRemoveClass(questionCurrent, 'current');
			progressSetClass(questionCurrent - 1, 'current');
			progressCircleSetPosition();

			selectedAnswers.pop();

			timeline
				.to($question, {
					xPercent: helpers.isMobile() ? 0 : 50,
					autoAlpha: 0,
				})
				.call(() => {
					$buttonNext
						.addClass('is-disabled')
						.prop('disabled', true);

					questionCurrent -= 1;
					questionSelectedAnswer = null;

					questionSet();
				})
				.set($question, {
					xPercent: helpers.isMobile() ? 0 : -50,
				})
				.to($question, {
					clearProps: 'all',
					autoAlpha: 1,
					xPercent: 0,
				});
		} else {
			questionSelectedAnswer = null;
			promptLeftCount = promptMaxCount;
			selectedAnswers = [];

			timeline
				.to($bottomBarStep, {
					yPercent: 100,
				})
				.to($step, {
					clearProps: 'all',
					autoAlpha: 0,
					xPercent: helpers.isMobile() ? 0 : 20,
				})
				.call(() => {
					$test.removeClass('is-started');
					$intro.removeClass('is-hidden');
					$step.addClass('is-hidden');

					$buttonNext
						.addClass('is-disabled')
						.prop('disabled', true);

					$promptButton
						.toggleClass('is-disabled', !promptLeftCount)
						.prop('disabled', !promptLeftCount);

					gsap.set($bottomBarStep, {clearProps: 'all'});

					progressRemoveClass();
					promptSetCount();
				})
				.from($intro, {
					clearProps: 'all',
					autoAlpha: 0,
					xPercent: helpers.isMobile() ? 0 : -20,
				});
		}
	});
};

const start = () => {
	return new Promise((resolve) => {
		if (isAnimating) {
			resolve();

			return;
		}

		isAnimating = true;

		questionSet();


		helpers.$document.trigger('test-start');

		$test
			.removeClass('is-intro')
			.addClass('is-started');

		gsap
			.timeline({
				onComplete() {
					isAnimating = false;

					resolve();
				},
			})
			.to($intro, {
				clearProps: 'all',
				autoAlpha: 0,
				xPercent: helpers.isMobile() ? 0 : -20,
			})
			.call(() => {
				$intro.addClass('is-hidden');
				$step.removeClass('is-hidden');
			})
			.from($step, {
				clearProps: 'all',
				autoAlpha: 0,
				xPercent: helpers.isMobile() ? 0 : 20,
			})
			.from($bottomBarStep, {
				clearProps: 'all',
				yPercent: 100,
			});
	});
};

const enter = (delay) => {
	$test.addClass('is-animating');

	if ($test.hasClass('is-visible')) {
		return;
	}

	const gsapElements = [
		$moon,
		$cosmonaut,
		$cloudLeft,
		$cloudRight,
		'.test__rules',
		'.test__rules .test__title',
		'.test__rules .test__text',
		'.test__description',
		'.test__description .test__title',
		'.test__description .test__text',
		'.test__description .test__button',
		'.test__intro .test__line',
		'.test__intro .test__photo-prompt',
		'.test__intro .test__arrow-down',
	];

	const durationBgObjects = 2.5;
	const durationElements = 0.4;
	const easeElastic = helpers.isMobile() ? 'elastic.out(1, 0.3)' : 'elastic.out(2, 0.3)';
	const xElements = -50;
	const yElements = 100;

	$('.test__intro .test__line').removeClass('is-active');

	gsap.killTweensOf(gsapElements);
	gsap.set(gsapElements, {clearProps: 'all'});

	gsap
		.timeline({
			onComplete() {
				$test.addClass('is-intro');
			},
			onStart() {
				$test.addClass('is-visible');
			},
			delay,
		})
		.from($moon, {
			clearProps: 'all',
			duration: durationBgObjects,
			ease: easeElastic,
			transition: 'none',
			yPercent: 100,
		})
		.from($cosmonaut, {
			clearProps: 'all',
			duration: durationBgObjects,
			ease: easeElastic,
			transition: 'none',
			yPercent: 75,
		}, 0)
		.from([$cloudLeft, $cloudRight], {
			clearProps: 'all',
			duration: durationBgObjects,
			ease: easeElastic,
			transition: 'none',
			yPercent: 50,
		}, 0.25)
		.from('.test__rules', {
			clearProps: 'all',
			duration: durationElements,
			transition: 'none',
			opacity: 0,
			y: yElements,
		}, 0.5)
		.from('.test__rules .test__title', {
			clearProps: 'all',
			duration: durationElements,
			transition: 'none',
			opacity: 0,
			y: yElements,
		}, 0.7)
		.from('.test__rules .test__text', {
			clearProps: 'all',
			duration: durationElements,
			transition: 'none',
			opacity: 0,
			y: yElements,
		}, 0.9)
		.from('.test__description', {
			clearProps: 'all',
			duration: durationElements,
			transition: 'none',
			opacity: 0,
			y: yElements,
		}, 1.1)
		.from('.test__description .test__title', {
			clearProps: 'all',
			duration: durationElements,
			transition: 'none',
			opacity: 0,
			y: yElements,
		}, 1.3)
		.from('.test__description .test__text', {
			clearProps: 'all',
			duration: durationElements,
			transition: 'none',
			opacity: 0,
			y: yElements,
		}, 1.5)
		.from('.test__description .test__button', {
			clearProps: 'all',
			duration: durationElements,
			transition: 'none',
			opacity: 0,
			y: yElements,
		}, 1.7)
		.from('.test__intro .test__line', {
			clearProps: 'all',
			duration: durationElements,
			transition: 'none',
			opacity: 0,
		}, 1.9)
		.call(() => {
			$('.test__intro .test__line').addClass('is-active');
		}, null, 2.1)
		.from('.test__intro .test__photo-prompt', {
			clearProps: 'all',
			duration: durationElements,
			transition: 'none',
			opacity: 0,
			x: xElements,
		}, 1.9)
		.from('.test__intro .test__arrow-down', {
			clearProps: 'all',
			duration: durationElements,
			transition: 'none',
			opacity: 0,
			x: xElements,
		}, 2.1);
};

const leave = () => {
	$test.removeClass('is-animating');

	if (!$test.hasClass('is-started') && !$test.hasClass('is-finished')) {
		$test.removeClass('is-visible');
	}
};

const resize = () => {
	sliderDestroy();
	sliderCreate();
	photoDraggableSetSharePosition();
	progressCircleSetPosition();
};

const init = () => {
	if (!$test.length) {
		return;
	}

	vars.$document.trigger('test-animate-false');

	sliderCreate();
	progressCreate();
	promptSetCount();

	helpers.$window.on('resize.test', resize);
	helpers.$document
		.on('click.test', '.test__button--start', start)
		.on('click.test', '.test__answer', questionSelectAnswer)
		.on('keydown.test', promptHideOnEscape);

	$prompt.on('click.test', promptHideOnClick);
	$bottomBarStep.on('click.test', promptHideOnClick);
	$buttonPrev.on('click.test', prev);
	$buttonNext.on('click.test', next);
	$buttonRepeat.on('click.test', repeat);
	$buttonUpload.on('click.test', fileTrigger);
	$buttonUploadPhoto.on('click.test', fileUploadState);
	$buttonUploadError.on('click.test', fileTriggerError);
	$promptButton.on('click.test', promptToggle);
	$file.on('change.test', fileUpload);
	$social.on('click.test', share);
};

init();

export default {
	enter,
	leave,
};
